import { defineComponent, computed, openBlock, createElementBlock, normalizeStyle, renderSlot } from "vue";
import { u as useComponentPresetProp } from "../../../../composables/useComponentPreset.js";
import { u as useColors } from "../../../../composables/useColors.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaCardTitle"
  },
  __name: "VaCardTitle",
  props: {
    ...useComponentPresetProp,
    textColor: { type: String }
  },
  setup(__props) {
    const props = __props;
    const { getColor } = useColors();
    const titleStyles = computed(() => ({
      color: props.textColor ? getColor(props.textColor) : ""
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "va-card-title va-card__title",
        style: normalizeStyle(titleStyles.value)
      }, [
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ], 4);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../../../VaCardTitle.css';
//# sourceMappingURL=VaCardTitle.vue_vue_type_script_setup_true_lang.js.map
